import { useEffect, useState, useTransition } from "react";
import { useSelector } from 'react-redux';
import Select from 'react-tailwindcss-select';
import styled from 'styled-components';

export const SelectCustomStyle = styled.div`
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
	height: 42px
}
`

function CompanyTableNavbar(props) {
    const { companyState, globalState } = useSelector((state) => state);
    const { active_count, inactive_count } = companyState;
    // const { t } = useTransition();

    useEffect(() => {
    }, [])

    const [selectTab, setSelectTab] = useState(0);
    const [sortby, setSortby] = useState({ value: 0, label: "Erstellt am" });
    const [showCount, setShowCount] = useState({ value: 0, label: "10" });

    var activeStyle = "flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 base active text-blue-600 rounded-t-lg border-b-2 border-sitebg-200 active dark:text-blue-500 dark:border-sitebg-300";
    var inactiveStyle = "flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 base active border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300";

    var sortName = ["Date Created", "Date Modified"]
    var sortName_de = ["Erstellt am", "Bearbeitet am"]
    var countName = ["10", "20", "50", "100"]
    var sort_options = [];
    var count_options = [];

    sortName && sortName.map((data, index) => {
        if(globalState.language == "de"){
            sort_options[index] = { value: index, label: sortName_de[index] }
        }else{
            sort_options[index] = { value: index, label: data }
        }
    });

    countName && countName.map((data, index) => {
        count_options[index] = { value: index, label: data }
    });

    const selectShowCount = (value) => {
        setShowCount(value);

        const { setCondition, getData } = props;
        setCondition("showCount", value.label);
        setCondition("currentPage", 0);
        getData();
    }

    const selectSortby = (value) => {
        setSortby(value);

        const { setCondition, getData } = props;
        setCondition("sortby", sortName[value.value]);
        setCondition("currentPage", 0);
        getData();
    }

    const selectState = (value) => {
        setSelectTab(value);

        const state_str = ["active", "inactive"];
        const { setCondition, getData } = props;
        setCondition("activeState", state_str[value]);
        setCondition("currentPage", 0);
        getData();
    }

    return (
      
        <div className="nabvar">
            <div className="navigations">
                <div className={selectTab === 0 ? 'navigation-item navigation-item-active' : 'navigation-item'} onClick={() => selectState(0)}>
                    <div className={selectTab === 0 ? 'text text-active' : 'text'}>{"Active"}</div>
                    <div className={selectTab === 0 ? 'badge badge-active' : 'badge'}>{active_count}</div>
                </div>

                <div className={selectTab === 1 ? 'navigation-item navigation-item-active' : 'navigation-item'} onClick={() => selectState(1)}>
                    <div className={selectTab === 1 ? 'text text-active' : 'text'}>{"Inactive"}</div>
                    <div className={selectTab === 1 ? 'badge badge-active' : 'badge'}>{inactive_count}</div>
                </div>
            </div>
            <div className="tools">
                <div className="flex items-center col-span-1 px-2 select-box">
                    <SelectCustomStyle style={{width: '100px'}}>
                        <Select
                            value={showCount}
                            onChange={value => selectShowCount(value)}
                            options={count_options}
                        />
                    </SelectCustomStyle>
                </div>
                <div className="flex items-center col-span-1 px-2 select-box">
                    <SelectCustomStyle>
                        <Select
                            value={sortby}
                            onChange={value => selectSortby(value)}
                            options={sort_options}
                        />
                    </SelectCustomStyle>
                </div>
            </div>
        </div>
    );
}

export default CompanyTableNavbar;
